<template>
  <div class="container_PFormSwitch">
    <div :class="giveMeClassSwitch" @click="change">
      <div></div>
    </div>
    <div class="label_PFormSwitch">{{ label }}</div>
  </div>
</template>
<script lang="ts">
import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export class PFormSwitch extends Vue {
  @Model("intput") readonly checked!: any;
  @Watch("checked")
  onChangeChecked(): void {
    this.isCheckedFun();
  }

  @Prop({ required: false, default: true }) value!: any;
  @Prop({ required: false, default: false }) unchecked_value!: any;
  @Prop({ required: false, default: false }) readonly!: boolean;
  @Prop({ required: false, default: "" }) label!: string;

  public isChecked: boolean;
  public defaultCheked: boolean;

  constructor() {
    super();
    this.isChecked = false;
    this.defaultCheked = false;
  }
  get giveMeClassSwitch(): string {
    let returnTemp = "";
    if (this.isChecked) {
      returnTemp = "checkTrue_PFormSwitch";
    } else {
      returnTemp = "checkFalse_PFormSwitch";
    }
    if (this.readonly) {
      returnTemp = returnTemp + " readonly_PFormSwitch";
    }
    return returnTemp;
  }

  change(): void {
    if (!this.readonly) {
      this.isChecked = !this.isChecked;
      if (this.isChecked) {
        this.$emit("intput", this.value);
        this.$emit("change", this.value);
      } else {
        this.$emit("intput", this.unchecked_value);
        this.$emit("change", this.unchecked_value);
      }
    }
  }
  isCheckedFun(): void {
    if (this.value === this.checked) {
      this.defaultCheked = true;
      this.isChecked = true;
    } else {
      this.defaultCheked = false;
      this.isChecked = false;
    }
  }

  mounted(): void {
    this.isCheckedFun();
  }
  get dameClassReadOnly(): string {
    if (this.readonly) {
      return "sololectura";
    } else {
      return "";
    }
  }
}
export default PFormSwitch;
</script>
<style scoped>
.container_PFormSwitch {
  display: flex;
  margin-top: 1rem;
}
.checkFalse_PFormSwitch,
.checkTrue_PFormSwitch {
  position: relative;
  width: 35px;
  height: 22px;
  border-radius: 15px;
  cursor: pointer;
  display: flex;
}
.checkTrue_PFormSwitch {
  background-color: #ffd102;
}
.checkFalse_PFormSwitch {
  background-color: #e4e4e4;
}
.checkFalse_PFormSwitch div,
.checkTrue_PFormSwitch div {
  position: absolute;
  top: 1px;
  width: 18px;
  height: 18px;
  border-radius: 100%;
  box-shadow: 0 3px 3px 0 rgb(0 0 0 / 5%), 0 2px 2px 0 rgb(0 0 0 / 10%), 0 3px 1px 0 rgb(0 0 0 / 5%);
  border: solid 0.5px rgba(0, 0, 0, 0.1);
  background-color: #fff;
}
.checkTrue_PFormSwitch div {
  right: 2px;
}
.checkFalse_PFormSwitch div {
  left: 2px;
}
.readonly_PFormSwitch {
  cursor: no-drop;
  opacity: 0.5;
}
.label_PFormSwitch {
  margin-left: 1rem;
}
</style>
